module.exports = __webpack_public_path__ + "static/media/IMG_5719.824df4c1.JPG";